<template>
  <v-card tile flat outlined>
    <v-hover v-slot="{ hover }">
      <div>
        <!-- Header -->
        <div class="d-flex align-center px-3 py-1" style="background: #f5f5f5; border-bottom: 1px solid #e0e0e0; min-height: 40px;">
          <span class="text-overline grey--text text--darken-2" style="font-weight: 500; letter-spacing: 1px;">
            Settimana {{ settimana.numero + 1 }}
          </span>
          <span class="text-caption grey--text ml-2">{{ rangeSettimana }}</span>
          <v-spacer />
          <template v-if="hover">
            <v-btn icon small color="green" class="mr-1" @click="$emit('aggiungi-arrivo', settimana)">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn icon small color="purple" @click="$emit('stampa-settimana', settimana)">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </template>
        </div>

        <!-- Corpo: lista arrivi -->
        <div class="pa-1" style="min-height: 72px;">
          <div v-if="!settimana.arrivi || settimana.arrivi.length === 0"
               class="d-flex align-center justify-center grey--text text--lighten-1 text-caption"
               style="min-height: 72px;">
            Nessun arrivo
          </div>
          <v-list v-else dense class="pa-0 transparent">
            <v-list-item
              v-for="arrivo in settimana.arrivi"
              :key="arrivo.id"
              class="pa-0 px-1"
              style="min-height: 34px; cursor: pointer;"
              @click="$emit('apri-dettaglio', { arrivo, settimana })"
            >
              <v-list-item-avatar size="32" class="mr-2">
                <v-img :src="avatarFornitore(arrivo.id_fornitore)" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ nomeFornitore(arrivo.id_fornitore) }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ totalePzArrivo(arrivo) }} pz
                  <v-icon v-if="arrivo.pdf" small color="red" class="ml-1">mdi-file-pdf-box</v-icon>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-hover>
  </v-card>
</template>

<script>
import moment from "moment";
export default {
  name: "SettimanaArriviCard",
  props: {
    settimana: { type: Object, required: true },
    fornitori:  { type: Array, default: () => [] },
  },
  computed: {
    haArrivi() {
      return this.settimana.arrivi && this.settimana.arrivi.length > 0;
    },
    rangeSettimana() {
      const start = moment().isoWeek(this.settimana.numero + 1).startOf("isoWeek");
      const end   = moment().isoWeek(this.settimana.numero + 1).endOf("isoWeek");
      return start.format("D MMM") + " – " + end.format("D MMM");
    },
  },
  methods: {
    avatarFornitore(id) {
      return process.env.VUE_APP_API_ROOT + "/fornitore/" + id + "/avatar";
    },
    nomeFornitore(id) {
      const f = this.fornitori.find((f) => f.id == id);
      return f ? f.nome : "Fornitore #" + id;
    },
    totalePzArrivo(arrivo) {
      if (!arrivo.prodotti || !arrivo.prodotti.length) return 0;
      return arrivo.prodotti.reduce((acc, p) => acc + (p.qta || 0), 0);
    },
  },
};
</script>
